import _ from 'lodash';
import { API_ROUTES, WAIVER_STATUS_CANCELLED, WAIVER_STATUS_PENDING } from '../constants';
import { getProperty } from '../fsConfig';
import { canEditWaivers } from '../configTdm';
import { Waiver } from '../../js/headersegment/interfaces';

const WaiverActions = {

  canEditWaiver: (waiver: Waiver): boolean => {
    let authorizedAirlineCodes = getProperty('session', {}).authorizedAirlineCodes || [];
    return (
      !waiver.cancelled && canEditWaivers() &&
      (authorizedAirlineCodes || []).includes(waiver.issuingAirlineCode || '')
    );
  },

  waiverUrl: (waiver: Waiver): string => {
    const baseUrl = `/waivers/${waiver.id}`;
    return WaiverActions.canEditWaiver(waiver) ? `${baseUrl}/edit` : baseUrl;
  },

  hasWaiverDocument: (waiver: Waiver): boolean => {
    return _.isNumber(waiver.documentId);
  },

  documentLink: (waiver: Waiver): string => {
    return API_ROUTES.waiverDocument
      .replace(':documentId', waiver.documentId!.toString())
      .replace(':fileName', waiver.documentName!);
  },

  waiverStatusDescription: (waiver: Waiver): string => {
    switch (waiver.status) {
      case WAIVER_STATUS_PENDING:
        return 'Pending';
      case WAIVER_STATUS_CANCELLED:
        return 'Cancelled';
      default:
        return 'Activated';
    }
  }

};

export default WaiverActions;